export default __webpack_public_path__ + "static/media/dotIcon.c4362cb2.svg";